import React from "react";
import { compose, graphql } from "react-apollo";
import { Button, Icon } from "semantic-ui-react";
import { RunFlightScheduleImport } from "../../../mutations/RunFlightScheduleImport";
import { FlightScheduleImportsConnection } from "../../../queries/FlightScheduleImportsConnectionMin";
import { statuses } from "./Steps";
import mapConnection from "../../../utils/connectionMapper";

const withFlightImportsData = compose(
  graphql(RunFlightScheduleImport, {
    name: "runImport",
    options: {
      notifyOnNetworkStatusChange: true
    }
  }),
  graphql(FlightScheduleImportsConnection, {
    options: () => ({
      variables: {
        first: 1,
        orderBy: [["created_at", "desc"]]
      }
    }),
    props: ({ data: { flightScheduleImportsConnection } }) => ({
      lastFlightScheduleImport: mapConnection(flightScheduleImportsConnection)
    })
  })
);
class TriggerPipelineButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.onClick = this.onClick.bind(this);
  }
  async onClick() {
    this.setState({ loading: true });
    await this.props.runImport({ variables: { input: {} } });
    this.setState({ loading: false });
  }

  render() {
    const { lastFlightScheduleImport } = this.props;

    const isManualRetryDisabled =
      Array.isArray(lastFlightScheduleImport) &&
      lastFlightScheduleImport[0] &&
      [
        statuses.queued,
        statuses.file_migration,
        statuses.db_backup,
        statuses.emr_run,
        statuses.waiting_for_csv
      ].includes(lastFlightScheduleImport[0].executionStatus);

    const { loading } = this.state;
    return (
      <Button
        onClick={this.onClick}
        color="blue"
        disabled={isManualRetryDisabled || loading}
      >
        {loading && <Icon name="spinner" loading />}
        Retry last import
      </Button>
    );
  }
}

export default withFlightImportsData(TriggerPipelineButton);



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/TriggerPipelineButton.js